import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';
import styles from '#components/common/teaser-box-audio-icon/teaserBoxAudioIcon.module.scss';
import IconCurve from '#components/icons/IconCurve';
import { Microphone } from '#components/icons';

type Props = {
  children: ReactNode;
  position?: 'left' | 'center';
  curveIcon?: boolean;
  extraClass?: string;
};

const TeaserBoxAudioIcon: FC<Props> = ({
  position = 'left',
  curveIcon = false,
  children,
  extraClass,
}) => {
  const className = classNames(styles.host, extraClass, {
    [styles.iconLeftAligned]: position === 'left' && !curveIcon,
    [styles.iconCentered]: position === 'center' && !curveIcon,
    [styles.iconWithCurve]: !!curveIcon,
  });

  return (
    <div className={className}>
      {children}
      {curveIcon && (
        <div className={styles.curve}>
          <IconCurve />
        </div>
      )}
      <div className={styles.icon}>
        <Microphone size={16} color="inherit" />
      </div>
    </div>
  );
};

export default TeaserBoxAudioIcon;
